import React, {useEffect, useRef, useState} from 'react';
import {Button, Dialog, DialogActions, DialogContent, Zoom} from '@mui/material';
import {useReactToPrint} from 'react-to-print';
import WristBandDesign from '../../../view/Landing/TicketDesignPrinting/WristBandDesign';
import {ticketsAction} from '../../../services/TicketsServices';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom style={{transitionDelay: '150ms'}} ref={ref} {...props}/>;
});


export default function SuccessPopup(props) {
  const {show, handleClose, ticketId} = props;
  const [ticket, setTicket] = useState({});
  const componentRef = useRef();

  useEffect(() => {
    if (ticketId) {
      getTicket();
    }
  },[ticketId]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const getTicket = () => {
    ticketsAction('get', ticketId).then(res => {
      setTicket(res?.data);
    })
  }

  return (
    <div>
      <Dialog
        open={show}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
        fullWidth={true}
        maxWidth={'sm'}
      >
        <DialogContent>
          <h3>Print your ticket!!! </h3>
          <WristBandDesign ref={componentRef} ticket={ticket}/>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant={'outlined'} color={'error'} className={'text-capitalize'}
                  sx={{width: 40, height: 30}}>cancel</Button>
          <Button variant={'contained'} onClick={handlePrint} className={'text-capitalize'}
                  sx={{width: 40, height: 30}}>Print</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}